<template>
  <div id="app">
    <transition :name="'page-'+$store.state.direction">
     <keep-alive :include="include">
          <router-view></router-view>
      </keep-alive>
    
    </transition>
  </div>
</template>

<script>

  import store from "./components/router-store";
  import flexible from "./plugins/flexible.js"
  import base from "./plugins/base.css"
  import user from "./components/login/user.js";
  export default {
    name: 'app',
   
    store,
    data(){
      return{
        include:['recommend','basicMsg',"docList","dtIndex",]
      }
    },
    created() {
     
    },
    mounted(){
       localStorage.setItem("time",new Date().getTime());
      require.ensure(["./components/svg-icon/"], function (require) {
        require("./components/svg-icon/");
      })
      if(this.getCookie('jwt')){
         this.getSet();
      }else{
        user.logout();
      }
    },
    methods:{
      getCookie(name) {
          var arr = document.cookie.match(new RegExp("(^| )"+name+"=([^;]*)(;|$)"));
          if(arr != null) {
            return unescape(arr[2]);
          }
          return null;
      },
      getSet() {
        this.$http.get('api/getset').then(res => {
          let j = res.data;
          if (j.code == 200) {
             user.pointLogin(j.data)
          }
        })
      }
    }
  }
</script>

<style lang="less">
#app{
  width:100%;
  height:100%;
}
  .l {
    float: left;
  }

  .r {
    float: right;
  }

  .cl {
    clear: both;
  }

  .n {
    font-weight: normal;
    font-style: normal;
  }

  .b {
    font-weight: bold;
  }

  .i {
    font-style: italic;
  }

  .tl {
    text-align: left;
  }

  .tc {
    text-align: center;
  }

  .tr {
    text-align: right;
  }

  .ti2 {
    text-indent: 2em;
  }

  .c0 {
    color: #000;
  }

  .c1 {
    color: #333;
  }

  .c2 {
    color: #666;
  }

  .c3 {
    color: #999;
  }

  .cm {
    color: #00b38b;
  }

  .co {
    color: #fe9001;
  }

  .cc {
    color: #CCC;
  }

  .cr {
    color: red;
  }

  .cw {
    color: #FFF;
  }

  /* font size */
  .f14 {
    font-size: 14px;
  }

  .f3s {
    font-size: .714em;
  }

  .f2s {
    font-size: .785em;
  }

  .f1s {
    font-size: .85em;
  }

  .fm {
    font-size: 1em;
  }

  .f1x {
    font-size: 1.14em;
  }

  .f2x {
    font-size: 1.28em;
  }

  .vt {
    vertical-align: top;
  }

  .vm {
    vertical-align: middle;
  }

  .vb {
    vertical-align: bottom;
  }

  .m0 {
    margin: 0;
  }

  .ml1 {
    margin-left: 1em;
  }

  .mr1 {
    margin-right: 1em;
  }

  .p0 {
    padding: 0;
  }

  .pl1 {
    padding-left: 1em;
  }

  .pr1 {
    padding-right: 1em;
  }

  .pr {
    position: relative;
  }

  .pa {
    position: absolute;
  }

  .ps {
    position: static;
  }

  .pf {
    position: fixed;
  }

  .dn {
    display: none;
  }

  .db {
    display: block;
  }

  .dib {
    display: inline-block;
  }

  .di {
    display: inline;
  }

  .oh {
    overflow: hidden;
  }

  .os {
    overflow: scroll;
  }

  .vh {
    visibility: hidden;
  }

  .vv {
    visibility: visible;
  }

  .cf:after {
    display: block;
    content: "";
    height: 0;
    clear: both;
    overflow: hidden;
    visibility: hidden;
  }

  .e {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .m {
    background: none no-repeat 50% 50%;
    background-size: contain;
  }

 

  .wpr2 {
    margin: 3%;
  }

  .con {
    padding: 0 3%;
  }

  .con2 {
    padding: 3%;
  }

  .bgw {
    background-color: #FFF;
  }

  .bgm {
    background-color: #f2f4f7 !important;
  }

  .mh {
    position: relative;
    transition: background-color .5s;
  }

  .mk:before,
  .mh:after {
    position: absolute;
    content: "";
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .mh:hover:after {
    background-color: rgba(0, 0, 0, .1);
  }

  .mk:before {
    background-color: rgba(0, 0, 0, .1);
  }

  .mk:hover:before {
    background-color: rgba(0, 0, 0, .2);
  }

  .empty-loading:empty {
    min-height: 4em;
  }

  .drag-load-tip {
    padding: 1em 0;
    font-size: .3rem;
  }

  /* 上拉加载更多底部提示 */
  .loading,
  .empty-loading:empty {
    background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHN0eWxlPmNpcmNsZXtzdHJva2UtZGFzaG9mZnNldDoxNjA7LXdlYmtpdC1hbmltYXRpb246YSAxLjZzIGluZmluaXRlO2FuaW1hdGlvbjphIDEuNnMgaW5maW5pdGU7fUAtd2Via2l0LWtleWZyYW1lcyBhezEwMCV7c3Ryb2tlLWRhc2hvZmZzZXQ6LTE2MDt9fUBrZXlmcmFtZXMgYXsxMDAle3N0cm9rZS1kYXNob2Zmc2V0Oi0xNjA7fX08L3N0eWxlPgo8Y2lyY2xlIGN4PSIzMC4zMTAyNSIgY3k9IjI5LjgzMjkzIiByPSIyMi45MTE2OSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjREREIiBzdHJva2Utd2lkdGg9IjYiIHN0cm9rZS1kYXNoYXJyYXk9IjE2MCwxNjAiIC8+Cjwvc3ZnPg==) no-repeat 50% 50%;
    background-size: 2em !important;
  }

  .clamp {
    line-height: 1.5em;
    max-height: 3em;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }


  .lazy-load {
    // background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%202176%20704%22%3E%0A%3Cg%20fill%3D%22%23DDDDDD%22%20transform%3D%22matrix%280.9999999%2C0%2C0%2C0.9999999%2C-340.3416%2C-0.01266935%29%22%3E%09%0A%09%3Cpath%20d%3D%22M900.5%2C235.5c-2.2%2C9.2-4.1%2C17.5-6.3%2C27c98.2%2C0%2C195.3%2C0%2C293.1%2C0c0%2C12.6%2C0%2C24.1%2C0%2C37%26%23xD%3B%0A%09%09c-25.1%2C0.6-50.3%2C0.2-75.4%2C0.3c-25%2C0.1-50%2C0-75%2C0c-25.3%2C0-50.7%2C0-76%2C0c-24.9%2C0-49.9%2C0-75.6%2C0c-15.7%2C66.3-31.2%2C131.9-46.8%2C197.8%26%23xD%3B%0A%09%09c-14.3%2C0-27.8%2C0-42.3%2C0c15.5-66%2C30.8-131.2%2C46.4-197.7c-19.4%2C0-37.6%2C0-57.1%2C0c-1.2-12.6-1-24.3-0.2-37.2c22.2%2C0%2C43.7%2C0%2C65.8%2C0%26%23xD%3B%0A%09%09c2.2-9.3%2C4.2-17.5%2C6.5-27c-19.4%2C0-37.9%2C0-57.1%2C0c0-12.2%2C0-23.3%2C0-35.6c21.6%2C0%2C43.1%2C0%2C65.5%2C0c2.2-9.5%2C4.2-18.1%2C6.6-28.2%26%23xD%3B%0A%09%09c-25.1%2C0-49.2%2C0-73.8%2C0c0-12.5%2C0-23.6%2C0-35.3c124.8%2C0%2C248.9%2C0%2C374.2%2C0c0.2%2C5.5%2C0.4%2C11%2C0.5%2C16.6c0.1%2C5.6%2C0%2C11.3%2C0%2C18.1%26%23xD%3B%0A%09%09c-4.5%2C0.2-8.3%2C0.5-12.1%2C0.5c-78%2C0-155.9%2C0-233.9%2C0c-3.9%2C0-7.8%2C0-12.1%2C0c-2.2%2C9.4-4.1%2C17.8-6.4%2C27.7c18.7%2C0%2C36.2%2C0.1%2C53.6%2C0.1%26%23xD%3B%0A%09%09c17.3%2C0%2C34.7%2C0%2C52%2C0c17.7%2C0%2C35.3%2C0%2C53%2C0c17.3%2C0%2C34.7%2C0%2C52%2C0c17.6%2C0%2C35.1%2C0%2C53.3%2C0c0%2C12.3%2C0%2C23.5%2C0%2C35.8%26%23xD%3B%0A%09%09C1082.1%2C235.5%2C991.6%2C235.5%2C900.5%2C235.5z%22%20/%3E%0A%09%3Cpath%20d%3D%22M1025.2%2C539.9c-39%2C0-77.9%2C0-116.9%2C0c-19.1%2C0-26.1-6.8-26.2-25.6c0-54.3-0.1-108.6%2C0-162.8%26%23xD%3B%0A%09%09c0-17.6%2C7.4-25.1%2C24.8-25.1c79.3-0.1%2C158.5-0.1%2C237.8%2C0c17.7%2C0%2C25.1%2C7.4%2C25.1%2C24.8c0%2C54.9%2C0%2C109.9%2C0%2C164.8%26%23xD%3B%0A%09%09c0%2C13.3-5.2%2C21.1-15.8%2C23.4c-3.2%2C0.7-6.6%2C0.5-9.9%2C0.5C1104.5%2C539.9%2C1064.9%2C539.9%2C1025.2%2C539.9z%20M922.4%2C504.3%26%23xD%3B%0A%09%09c16.9%2C2.2%2C198.1%2C1.4%2C205.5-1c0-3.8%2C0-7.7%2C0-11.7c0-4.2%2C0-8.5%2C0-13.1c-69.1%2C0-137.1%2C0-205.5%2C0C922.4%2C487.5%2C922.4%2C495.7%2C922.4%2C504.3z%26%23xD%3B%0A%09%09%20M1127.3%2C421.5c-12.4-2-197.8-1.5-205.3%2C0.6c0%2C3.8%2C0%2C7.8%2C0%2C11.8c0.1%2C3.9%2C0.2%2C7.7%2C0.3%2C11.6c69%2C0%2C136.8%2C0%2C205%2C0%26%23xD%3B%0A%09%09C1127.3%2C437%2C1127.3%2C429.2%2C1127.3%2C421.5z%20M922.3%2C387c15.6%2C2.3%2C198.4%2C1.5%2C204.7-0.6c0-7.3%2C0-14.4%2C0-21.4c-68.7%2C0-136.5%2C0-204.7%2C0%26%23xD%3B%0A%09%09C922.3%2C372.6%2C922.3%2C379.5%2C922.3%2C387z%22%20/%3E%0A%09%3Cpath%20d%3D%22M1224.8%2C290.3c0-12.4%2C0-23.6%2C0-36.2c29.6-0.4%2C59.1-0.1%2C88.6-0.2c29.6%2C0%2C59.3%2C0%2C90.1%2C0c1.1-9.9%2C0.4-19.5%2C0.5-29%26%23xD%3B%0A%09%09c0.1-9.3%2C0-18.7%2C0-28c0-9.7%2C0-19.3%2C0-29c0-9.2%2C0-18.5%2C0-28.5c14.6%2C0%2C28%2C0%2C42.5%2C0c0%2C38.1%2C0%2C75.7%2C0%2C114.2c59.8%2C0%2C118.6%2C0%2C178.3%2C0%26%23xD%3B%0A%09%09c0%2C12.4%2C0%2C23.8%2C0%2C36.5c-58.1%2C0-115.9%2C0-174.7%2C0c8%2C50.2%2C29.1%2C93.1%2C59%2C131.8c30.4%2C39.3%2C69.5%2C66.6%2C117.8%2C80.2c0%2C13.2%2C0%2C25.6%2C0%2C38.6%26%23xD%3B%0A%09%09c-19.1-0.4-36-6-52.3-13.6c-25.6-11.9-48.1-28.3-68.6-47.7c-30.2-28.4-54.4-61.1-71.8-98.8c-2.5-5.4-5.3-10.6-8.9-17.9%26%23xD%3B%0A%09%09c-2.3%2C4.7-4.1%2C7.6-5.3%2C10.7c-15.6%2C39.4-39.9%2C72.9-70.5%2C101.9c-32.4%2C30.9-69%2C54.3-113.6%2C63.5c-3.6%2C0.7-7.1%2C1.4-11.5%2C2.2%26%23xD%3B%0A%09%09c0-13%2C0-25.4%2C0-37.8c101.3-35.1%2C153.4-110.6%2C176.2-212.8c-30.2-0.3-59.4-0.1-88.5-0.1C1283.1%2C290.3%2C1254.2%2C290.3%2C1224.8%2C290.3z%22%20/%3E%0A%09%3Cpath%20d%3D%22M2085.6%2C499.9c0%2C12.9%2C0%2C24%2C0%2C35.9c-3.8%2C0.2-7%2C0.5-10.3%2C0.5c-109.3%2C0-218.7-0.3-328%2C0.3%26%23xD%3B%0A%09%09c-27.4%2C0.2-58.8-21.6-58.7-59c0.3-95.3%2C0.1-190.7%2C0.1-286c0-34.5%2C24.5-59.2%2C59.2-59.2c69.3-0.2%2C138.7%2C0%2C208%2C0c39.3%2C0%2C78.7%2C0%2C118%2C0%26%23xD%3B%0A%09%09c3.6%2C0%2C7.2%2C0%2C11.5%2C0c0%2C12.8%2C0%2C24.6%2C0%2C37.5c-4.4%2C0-8.3%2C0-12.2%2C0c-105.7%2C0-211.3%2C0-317%2C0c-4.3%2C0-8.8%2C0-12.8%2C1.2%26%23xD%3B%0A%09%09c-11.2%2C3.4-17.6%2C12.5-17.6%2C25c-0.1%2C38.7%2C0%2C77.3%2C0%2C116c0%2C52.3%2C0%2C104.7%2C0%2C157c0%2C21.6%2C9.3%2C30.9%2C31.1%2C30.9c105.3%2C0%2C210.7%2C0%2C316%2C0%26%23xD%3B%0A%09%09C2076.9%2C499.9%2C2080.8%2C499.9%2C2085.6%2C499.9z%22%20/%3E%0A%09%3Cpath%20d%3D%22M1866.7%2C355.1c-40%2C0-77.9%2C0-116.3%2C0c0-12.2%2C0-23.4%2C0-35.9c3.5-0.2%2C7-0.6%2C10.4-0.6c37%2C0%2C74%2C0%2C111%2C0%26%23xD%3B%0A%09%09c11%2C0%2C11%2C0%2C14.3-10.9c4.6-15.7%2C8.2-31.5%2C7.9-49.3c-12.2-0.5-24.1-0.2-36-0.3c-11.7-0.1-23.3%2C0-35%2C0c-12%2C0-24%2C0-36%2C0%26%23xD%3B%0A%09%09c-11.6%2C0-23.3%2C0-36%2C0c-1.1-22.1-0.4-43.5-0.5-65.5c14.1%2C0%2C26.9%2C0%2C40.9%2C0c0%2C9.2%2C0%2C18.3%2C0%2C29c32.9%2C0.5%2C64.7%2C0.2%2C96.5%2C0.3%26%23xD%3B%0A%09%09c32.3%2C0.1%2C64.7%2C0%2C97%2C0c31.9%2C0%2C63.8%2C0%2C96.4%2C0c0%2C12.2%2C0%2C23.4%2C0%2C35.8c-25.2%2C1.1-50.3%2C0.4-75.5%2C0.5c-24.9%2C0.1-49.8%2C0-74.4%2C0%26%23xD%3B%0A%09%09c-3.5%2C21.1-6.8%2C41-10.2%2C61.2c52.9%2C0%2C106.1%2C0%2C160.4%2C0c1%2C11.6%2C0.2%2C23.1%2C0.5%2C36c-37.4%2C0.2-74.2%2C0-110.9%2C0.1c-0.3%2C0.7-0.7%2C1.4-1%2C2.2%26%23xD%3B%0A%09%09c34.7%2C34.7%2C69.4%2C69.4%2C104.8%2C104.9c-8.3%2C9-16.1%2C17.4-24.4%2C26.4c-47.6-45-94.4-89.3-141.7-134.1c-1.6%2C2.2-2.7%2C3.4-3.4%2C4.8%26%23xD%3B%0A%09%09c-18%2C37.2-46.3%2C65-81.1%2C86.1c-19.6%2C11.9-40.6%2C21.4-61.1%2C31.9c-2.3%2C1.2-4.9%2C1.8-8.6%2C3c-4.5-10.1-8.9-20-13.6-30.6%26%23xD%3B%0A%09%09c3.3-1.6%2C5.8-3%2C8.4-4.2c26.2-11.7%2C52.1-24.1%2C74.7-42c14.7-11.7%2C27.9-24.8%2C38-40.7C1863.5%2C361.2%2C1864.5%2C359.1%2C1866.7%2C355.1z%22%20/%3E%09%0A%3C/g%3E%0A%3C/svg%3E);
    // background-size: 50% auto !important;
  }

  .space {
    padding-bottom: 5em;
  }



  ::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 10px;
    background: rgba(0, 0, 0, .5);
  }

  html {
    height: 100%;
    font-size: 10vw;
    overflow: hidden;
  }

  .pc {
    font-size: 64px;
    width: 640px;
    margin: 0 auto;
    background: #EEE;
  }

  body {
    position: relative;
    min-width: 320px;
    height: 100%;
    
    font: normal 0.37333em/1.8 "Microsoft YaHei", Verdana, Tahoma;
    color: #333;
  
    background: #FFFF;
  }

  body, ul, dl, dt, dd {
    margin: 0;
    padding: 0;
  }

  ul {
    list-style-type: none;
  }

  li {
    list-style: none;
  }

  a {
    color: currentColor;
    text-decoration: none;
  }

  img {
    max-width: 100%;
  }

  a img {
    border: none;
  }

  /*input {*/
    /*-webkit-appearance: none;*/
  /*}*/

  video::-internal-media-controls-download-button {
    display: none;
  }

  video::-webkit-media-controls-enclosure {
    overflow: hidden;
  }

  video::-webkit-media-controls-panel {
    width: calc(~"100% + 30px");
  }

  /* 页面切换动画 */
  .page {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #FFF;
    -webkit-overflow-scrolling: touch;
  }

  .page-forward-enter-to,
  .page-forward-leave-to,
  .page-backward-enter-to,
  .page-backward-leave-to {
    transition: all .3s;
    background: #FFF;
  }

  .page-forward-enter-to,
  .page-backward-enter-to {
    height: 100%;
    top: 0;
    position: absolute;
  }

  .page-forward-enter {
    transform: translate(100%, 0) translateZ(0);
  }

  .page-forward-leave-to {
    transform: translate(-80%, 0) translateZ(0);
  }

  .page-backward-enter {
    transform: translate(-100%, 0) translateZ(0);
  }

  .page-backward-leave-to {
    transform: translate(80%, 0) translateZ(0);
  }

  /* 标题 */
  .com-tit {
    font-size: .48rem;
    font-weight: 400;
    margin: 0;
    padding: .5em 3%;
    border-top: 10px solid #f0f4f7;
    border-bottom: 1px solid #f0f4f7;
  }

  .com-tit:before {
    display: inline-block;
    content: "";
    width: .3em;
    height: 1em;
    margin-top: -0.2em;
    margin-right: .2em;
    vertical-align: middle;
    background: #00b38b;
  }

  .com-tit > .ml1 {
    font-size: .86em;
  }

  .com-tit > .i-right {
    padding-right: 1em;
    background-repeat: no-repeat;
    background-position: 100% 50%;
    background-size: auto 1em;
  }

  /* 按钮 */
  .border-btn {
    font-size: .416rem;
    height: 2.8em;
    line-height: 2.8em;
    color: #00b38b;
    border: 1px solid #00b38b;
    border-radius: 1.5em;
    text-align: center;
    background-color: #FFF;
    cursor: pointer;
    outline: none;
  }

  .border-btn[title] {
    position: relative;
    color: transparent !important;
  }

  .border-btn:before {
    position: absolute;
    content: attr(title);
    left: -50%;
    top: 50%;
    width: 200%;
    white-space: nowrap;
    font-size: 2em;
    transform: translate(-1px, -50%) scale(.5);
    color: #00b38b;
  }

  .border-btn.on {
    color: #FFF;
    background-color: #00b38b;
  }

  .border-btn.on:before {
    color: #FFF !important;
  }

  /* 表单 */
  .form {
    font-size: .384rem;
  }
  .form input.r {
    width: calc(~"100% - 6em");
    font-size: 1em;
    text-align: right;
    margin: 0;
    margin-top: .7em;
    border: 0;
    outline: none;
  }
  .form input.mr {
    width: calc(~"100% - 6em");
    font-size: 1em;
    margin: 0;
    margin-top: .7em;
    border: 0;
    outline: none;
  }

  .form-item > label.db {
    margin-top: .6em;
    padding: .8em 0;
    border-bottom: 1px solid #DDD;
  }

  .form-item > .border-btn {
    display: block;
    width: 100%;
  }

  .form-item > .border-btn:disabled {
    border-color: #CCC;
    background-color: #CCC;
    cursor: default;
  }

  .mt1 {
    margin-top: 1em;
  }

  .mt6 {
    margin-top: 4em;
  }

  .form input.code-inp {
    width: calc(~"100% - 13em");
    margin-right: 6.5em;
  }
  .cms-btn{
    position: absolute;
    top:0.7em;
    right: 1.2em;
    background: #00b38b;
    color:#fff;
    cursor: pointer;
    height: 2em;
    line-height: 2em;
    width: 6em;
    font-size: 0.9em;
    border: 0;
    border-radius: 5px;
  }

  .cms-btn:disabled {
    background: #CCC;
  }

  .err {
    color: red;
  }

  /* 底部有关闭按钮的层 */
  .bottom-close-layer > .dialog-box {
    width: 8rem;
    max-width: 570px;
  }

  .bottom-close-layer > .dialog-box {
    border-radius: 5px;
  }

  .bottom-close-layer > .dialog-box > .dialog-body {
    padding: 0;
  }

  .bottom-close-layer > .dialog-box > .dialog-close-btn {
    position: absolute;
    width: 10%;
    left: 45%;
    top: 100%;
    margin-top: 3em;
    padding-top: 10%;
    height: 0;
    right: auto;
    background-image: url(data:image/svg+xml;charset=utf8,%0A%20%20%3Csvg%20viewBox%3D%220%200%201024%201024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20fill%3D%22%23FFF%22%20d%3D%22M981.671173%20312.397934c-25.782498-60.159162-62.737412-116.021241-109.145908-162.429738S770.254689%2065.74537%20709.23611%2039.962872c-125.474824-53.28383-272.435063-53.28383-397.909886%200-60.159162%2025.782498-116.021241%2062.737412-162.429738%20109.145908S65.533075%20252.238773%2039.750578%20312.397934C13.96808%20375.135346%200.217414%20442.169841%200.217414%20512.642003s13.750665%20137.506656%2039.533163%20200.244068c25.782498%2060.159162%2062.737412%20116.021241%20109.145908%20162.429738%2046.408496%2046.408496%20102.270576%2083.36341%20162.429738%20109.145908%2062.737412%2025.782498%20130.631324%2039.533163%20200.244068%2039.533163s134.928406-13.750665%20200.244068-39.533163c60.159162-25.782498%20116.021241-62.737412%20162.429738-109.145908%2046.408496-46.408496%2083.36341-102.270576%20109.145908-162.429738%2025.782498-62.737412%2039.533163-130.631324%2039.533163-200.244068S1007.453671%20375.135346%20981.671173%20312.397934zM936.981509%20693.978905c-23.204248%2055.862079-55.862079%20104.848826-99.692326%20148.679072-42.111413%2042.111413-92.816993%2076.488078-148.679072%2099.692326-114.302407%2048.986746-246.652565%2048.986746-362.673806%200-55.862079-23.204248-104.848826-58.440329-148.679072-99.692326-42.111413-42.111413-76.488078-92.816993-99.692326-148.679072-23.204248-58.440329-36.954914-118.599491-36.954914-181.336902%200-62.737412%2012.031833-122.896574%2036.954914-181.336902%2023.204248-55.862079%2055.862079-104.848826%2099.692326-148.679072%2042.111413-42.111413%2092.816993-76.488078%20148.679072-99.692326C383.517218%2058.870038%20444.535797%2045.119371%20507.273209%2045.119371s122.896574%2012.031833%20181.336902%2036.954914c55.862079%2023.204248%20104.848826%2055.862079%20148.679072%2099.692326%2042.111413%2042.111413%2076.488078%2092.816993%2099.692326%20148.679072%2023.204248%2058.440329%2036.954914%20118.599491%2036.954914%20181.336902C974.79584%20575.379414%20962.764007%20635.538576%20936.981509%20693.978905zM753.925773%20300.366102%20718.689693%20268.567688%20509.851459%20479.984172%20293.278475%20263.411188%20260.620644%20296.069019%20477.193628%20512.642003%20264.917727%20724.058487%20297.575558%20756.716317%20509.851459%20545.299834%20725.565025%20761.0134%20758.222856%20728.355569%20541.649873%20512.642003Z%22%3E%3C/path%3E%3C/svg%3E);
    background-size: contain;
  }

  /* 公用 icon */
  .i-play:after {
    background-image: url(data:image/svg+xml;base64,PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEtZmxhdC0yMDAzMDExNC5kdGQiPgo8c3ZnIHdpZHRoPSIxMDI0IiBoZWlnaHQ9IjEwMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMzAiIGZpbGw9Im5vbmUiIGQ9Ik0xNDUuNjY2MDQ4IDk3LjEzNjY0IDE0NS42NjYwNDggOTQ5LjI5MjAzMmw3MzQuODMxNjE2LTQyNi4wNzgyMDhMMTQ1LjY2NjA0OCA5Ny4xMzY2NHoiPjwvcGF0aD48L3N2Zz4=)
  }

  .i-cir-close {
    background-image: url(data:image/svg+xml;charset=utf8,%0A%20%20%3Csvg%20viewBox%3D%220%200%201024%201024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20fill%3D%22%23FFF%22%20d%3D%22M981.671173%20312.397934c-25.782498-60.159162-62.737412-116.021241-109.145908-162.429738S770.254689%2065.74537%20709.23611%2039.962872c-125.474824-53.28383-272.435063-53.28383-397.909886%200-60.159162%2025.782498-116.021241%2062.737412-162.429738%20109.145908S65.533075%20252.238773%2039.750578%20312.397934C13.96808%20375.135346%200.217414%20442.169841%200.217414%20512.642003s13.750665%20137.506656%2039.533163%20200.244068c25.782498%2060.159162%2062.737412%20116.021241%20109.145908%20162.429738%2046.408496%2046.408496%20102.270576%2083.36341%20162.429738%20109.145908%2062.737412%2025.782498%20130.631324%2039.533163%20200.244068%2039.533163s134.928406-13.750665%20200.244068-39.533163c60.159162-25.782498%20116.021241-62.737412%20162.429738-109.145908%2046.408496-46.408496%2083.36341-102.270576%20109.145908-162.429738%2025.782498-62.737412%2039.533163-130.631324%2039.533163-200.244068S1007.453671%20375.135346%20981.671173%20312.397934zM936.981509%20693.978905c-23.204248%2055.862079-55.862079%20104.848826-99.692326%20148.679072-42.111413%2042.111413-92.816993%2076.488078-148.679072%2099.692326-114.302407%2048.986746-246.652565%2048.986746-362.673806%200-55.862079-23.204248-104.848826-58.440329-148.679072-99.692326-42.111413-42.111413-76.488078-92.816993-99.692326-148.679072-23.204248-58.440329-36.954914-118.599491-36.954914-181.336902%200-62.737412%2012.031833-122.896574%2036.954914-181.336902%2023.204248-55.862079%2055.862079-104.848826%2099.692326-148.679072%2042.111413-42.111413%2092.816993-76.488078%20148.679072-99.692326C383.517218%2058.870038%20444.535797%2045.119371%20507.273209%2045.119371s122.896574%2012.031833%20181.336902%2036.954914c55.862079%2023.204248%20104.848826%2055.862079%20148.679072%2099.692326%2042.111413%2042.111413%2076.488078%2092.816993%2099.692326%20148.679072%2023.204248%2058.440329%2036.954914%20118.599491%2036.954914%20181.336902C974.79584%20575.379414%20962.764007%20635.538576%20936.981509%20693.978905zM753.925773%20300.366102%20718.689693%20268.567688%20509.851459%20479.984172%20293.278475%20263.411188%20260.620644%20296.069019%20477.193628%20512.642003%20264.917727%20724.058487%20297.575558%20756.716317%20509.851459%20545.299834%20725.565025%20761.0134%20758.222856%20728.355569%20541.649873%20512.642003Z%22%3E%3C/path%3E%3C/svg%3E) !important;
  }

  .i-right {
    background-image: url(data:image/svg+xml;base64,PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEtZmxhdC0yMDAzMDExNC5kdGQiPgo8c3ZnIHdpZHRoPSIxMDI0IiBoZWlnaHQ9IjEwMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjYWRhZGFkIiBkPSJNNzUxLjU1MiA1NTEuOTM1OTk5OTk5OTk5OUwzNTIuMzIwMDAwMDAwMDAwNCA5NTEuMTY3OTk5OTk5OTk5OWMtMjIuMDc5OTk5OTk5OTk5OTkgMjIuMDgwMDAwMDAwMDAwMDEtNTcuNzkxOTk5OTk5OTk5OTggMjIuMDgwMDAwMDAwMDAwMDE2LTc5Ljg3MTk5OTk5OTk5OTk5IDQuMjYzMjU2NDE0NTYwNjAxZS0xNC0yMi4wMTYwMDAwMDAwMDAwMDUtMjIuMDE1OTk5OTk5OTk5OTg4LTIyLjA4MDAwMDAwMDAwMDAxNi01Ny43OTE5OTk5OTk5OTk5OC00LjI2MzI1NjQxNDU2MDYwMWUtMTQtNzkuODcxOTk5OTk5OTk5OTlMNjMxLjc0NCA1MTEuOTk5OTk5OTk5OTk5OWwtMzU5LjI5NjAwMDAwMDAwMDE2LTM1OS4yOTU5OTk5OTk5OTk5Yy0yMi4wMTYwMDAwMDAwMDAwMDUtMjIuMDE1OTk5OTk5OTk5OTg4LTIyLjA4MDAwMDAwMDAwMDAxNi01Ny43OTE5OTk5OTk5OTk5OC00LjI2MzI1NjQxNDU2MDYwMWUtMTQtNzkuODcxOTk5OTk5OTk5OTkgMjIuMDc5OTk5OTk5OTk5OTktMjIuMDgwMDAwMDAwMDAwMDEgNTcuNzkxOTk5OTk5OTk5OTgtMjIuMDE2MDAwMDAwMDAwMDIzIDc5Ljg3MTk5OTk5OTk5OTk5LTQuMjYzMjU2NDE0NTYwNjAxZS0xNGwzOTkuMjMyMDAwMDAwMDAwMjYgMzk5LjIzMTk5OTk5OTk5OTg2Qzc3My41NjggNDk0LjE0NCA3NzMuNTY4IDUyOS44NTU5OTk5OTk5OTk5IDc1MS41NTIgNTUxLjkzNTk5OTk5OTk5OTl6Ij48L3BhdGg+PC9zdmc+);
  }
  input[type=button], input[type=submit], input[type=file], button { cursor: pointer; -webkit-appearance: none; }
</style>



// WEBPACK FOOTER //
// src/App.vue